import * as React from "react";
import axios from "axios";
import styled from "../../styled-components";
import { Container } from "../../components/Container/Container";
import { SmallDivider } from "../../components/SmallDivider/SmallDivider";
import { DepartmentAccordion } from "./DepartmentAccordion";

const Section = styled.section`
  background-color: #f2f2f2;
  padding: 100px 20px;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.black};
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
`;

const Descritpiton = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 30px;
  font-weight: 400px;
  line-height: 40px;
  text-align: center;
`;

const DepartmentsWrapper = styled.div`
  margin-top: 70px;
  width: 100%;
`;

const EmptyPositions = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
`;

const TextLink = styled.a`
  color: ${({ theme }) => theme.colors.blue};
  text-decoration: none;
`;

interface IDepartment {
  title: string;
  postings: IPosting[];
}

interface IPosting {
  id: string;
  text: string;
  hostedUrl: string;
  categories: { commitment: string; location: string };
}

interface IPositionsSectionState {
  departments: IDepartment[];
}

export class PositionsSeciton extends React.Component<
  {},
  IPositionsSectionState
> {
  public state: IPositionsSectionState = {
    departments: []
  };

  public componentDidMount() {
    this.fetchPositions();
  }

  public render() {
    const { departments } = this.state;
    const departmentList = () =>
      departments.map((department, index) => {
        return (
          <DepartmentAccordion
            departmentName={department.title}
            postings={department.postings}
            key={index}
          />
        );
      });

    return (
      <Section>
        <Container alignItems="center" flexDirection="column" maxwidth={680}>
          <Title>Departments</Title>
          <SmallDivider />
          <Descritpiton>View current openings with the Say team.</Descritpiton>

          <DepartmentsWrapper>
            {departments.length ? (
              departmentList()
            ) : (
              <EmptyPositions>
                We are not currently looking to fill specific roles, but are
                always looking for exceptional people to add to the team. If
                you’re a good fit send your resume to{" "}
                <TextLink href="mailto:jobs@saytechnologies.com">
                  jobs@saytechnologies.com
                </TextLink>
                .
              </EmptyPositions>
            )}
          </DepartmentsWrapper>
        </Container>
      </Section>
    );
  }

  private async fetchPositions() {
    try {
      const response = await axios.get(
        "https://api.lever.co/v0/postings/say?group=team&mode=json"
      );
      this.setState({
        departments: response.data
      });
    } catch (error) {
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Careers/PositionsSection.tsx